// extracted by mini-css-extract-plugin
export default {"container":"style_container__WqEb-","actionIcon":"style_actionIcon__bYD25","emptyRow":"style_emptyRow__Y6RZH","textNew":"style_textNew__dV0Cp","tag":"style_tag__+IFNX"};